import React, { useCallback, useEffect, useState } from "react";
import { Button } from "../index";
import { DOCUMENT_ACTION } from "../../redux/action";
import { Toaster } from "../../utils/common";
import { parseDocuSignConsentError } from "../../utils/docusignSignature";
import "./docusign-connection-status.scss";

function getStatusLabel(response) {
  const connected =
    response?.data?.connected ??
    response?.data?.is_connected ??
    response?.connected;
  const accountId =
    response?.data?.account_id || response?.data?.accountId || "";
  const userName =
    response?.data?.user_name ||
    response?.data?.userName ||
    response?.data?.email ||
    "";

  const ok = response?.data?.ok ?? response?.ok;
  if (connected === true || ok === true) {
    return `Connected${userName ? ` as ${userName}` : ""}${
      accountId ? ` (account ${accountId})` : ""
    }`;
  }
  if (connected === false || ok === false) {
    return response?.message || "Not connected";
  }
  return response?.message || "Status unknown";
}

export default function DocuSignConnectionStatus() {
  const [loading, setLoading] = useState(false);
  const [statusText, setStatusText] = useState("");

  const checkStatus = useCallback(async () => {
    setLoading(true);
    try {
      const response = await DOCUMENT_ACTION.getDocuSignAuthStatus();
      if (response?.status === 1 || response?.data) {
        const ok = response?.data?.ok === true;
        setStatusText(getStatusLabel(response));
        if (!ok) {
          Toaster.warning(
            response?.message ||
              "SignWell is not configured. Set SIGNWELL_API_KEY on the server.",
          );
        }
        return;
      }
      setStatusText(
        response?.message || "Unable to verify the SignWell connection.",
      );
    } catch (error) {
      const consentError = parseDocuSignConsentError(error);
      setStatusText(
        consentError.message || "Unable to verify the SignWell connection.",
      );
      Toaster.error(
        consentError.message || "Unable to verify the SignWell connection.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkStatus();
  }, [checkStatus]);

  return (
    <div className="docusign-connection-status">
      <div>
        <strong>SignWell</strong>
        <p>{loading && !statusText ? "Checking…" : statusText || "—"}</p>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <Button
          type="button"
          variant="outline"
          text={loading ? "Testing…" : "Test connection"}
          disable={loading}
          handleClick={checkStatus}
        />
      </div>
    </div>
  );
}
